var _g, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolana(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 659,
    height: 659,
    viewBox: "0 0 659 659",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_873_441)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 329.408,
    cy: 329.408,
    r: 197.61,
    transform: "rotate(-23.1621 329.408 329.408)",
    fill: "url(#paint0_linear_873_441)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_iii_873_441)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 336.709,
    cy: 348.699,
    rx: 121.586,
    ry: 121.586,
    transform: "rotate(81.203 336.709 348.699)",
    fill: "url(#paint1_linear_873_441)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.054 360.753C300.761 360.301 301.631 360.138 302.474 360.324L378.967 377.212C380.365 377.521 380.69 379.366 379.483 380.138L361.028 391.951C360.322 392.403 359.452 392.566 358.609 392.379L282.116 375.492C280.718 375.183 280.393 373.337 281.599 372.565L300.054 360.753Z",
    fill: "url(#paint2_linear_873_441)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.541 304.194C313.271 303.747 314.141 303.584 314.961 303.765L391.453 320.653C392.851 320.961 393.177 322.807 391.97 323.579L373.515 335.392C372.808 335.844 371.938 336.006 371.095 335.82L294.602 318.932C293.205 318.624 292.879 316.778 294.086 316.006L312.541 304.194Z",
    fill: "url(#paint3_linear_873_441)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.045 346.578C370.595 345.87 369.874 345.356 369.03 345.17L292.538 328.282C291.14 327.974 290.068 329.511 290.837 330.719L302.603 349.204C303.054 349.911 303.774 350.425 304.618 350.611L381.11 367.499C382.508 367.808 383.581 366.271 382.811 365.062L371.045 346.578Z",
    fill: "url(#paint4_linear_873_441)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_873_441",
    x: 0.663239,
    y: 0.663422,
    width: 657.49,
    height: 657.49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 65.5422,
    result: "effect1_foregroundBlur_873_441"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_iii_873_441",
    x: 182.21,
    y: 180.103,
    width: 276.102,
    height: 308.997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -32.8948,
    dy: -46.9926
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.6026
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.676044 0 0 0 0 0.235556 0 0 0 0 0.883333 0 0 0 0.76 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_873_441"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 18.797
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.7778
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.7625 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_873_441",
    result: "effect2_innerShadow_873_441"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.2667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_873_441",
    result: "effect3_innerShadow_873_441"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_873_441",
    x1: 329.408,
    y1: 131.798,
    x2: 329.408,
    y2: 527.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A490C0",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35BEA9",
    stopOpacity: 0.46
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_873_441",
    x1: 223.401,
    y1: 301.617,
    x2: 366.717,
    y2: 361.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF9AD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#64839A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#136A5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_873_441",
    x1: 386.144,
    y1: 309.991,
    x2: 310.579,
    y2: 399.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_873_441",
    x1: 365.671,
    y1: 292.765,
    x2: 290.105,
    y2: 382.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_873_441",
    x1: 375.842,
    y1: 301.323,
    x2: 300.276,
    y2: 391.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolana);
export default __webpack_public_path__ + "static/media/solana.a75957e84efe989f9e8270122fd07175.svg";
export { ForwardRef as ReactComponent };